import React from 'react';
import cx from 'classnames';
import PropTypes from 'prop-types';

import Modal from '../../common/Modal';
import { t } from '../../../modules/infra/i18n';

const SelectReader = ({ readers, selectReader, cancel, isProcessor, strategy }) => {
  const className = cx({ 'c-modal__shadowed': isProcessor });
  const overlayClassName = cx({ 'u-bg-transparent': isProcessor });
  return (
    <Modal
      title={t('register:web_reader.choose_reader')}
      close={cancel}
      showCloseButton
      className={className}
      overlayClassName={overlayClassName}
    >
      {readers.map(reader => (
        <button
          key={reader.id}
          type="button"
          className="c-btn u-1/1"
          onClick={() => selectReader(reader, strategy)}
        >
          {reader.label}
        </button>
      ))}
    </Modal>
  );
};

SelectReader.propTypes = {
  isProcessor: PropTypes.bool,
  cancel: PropTypes.func.isRequired,
  readers: PropTypes.array.isRequired,
  selectReader: PropTypes.func.isRequired,
  strategy: PropTypes.string.isRequired,
};

SelectReader.defaultProps = {
  isProcessor: false,
};

export default SelectReader;
